module.exports = __webpack_public_path__ + "img/3.02a620c2.png";